import { ActionAny, createActions } from 'src/utils/createActions';

export type KeyPhraseSynonymsResetActions =
    ActionAny<void, void>;
export const KEY_PHRASE_SYNONYMS_RESET_ACTIONS =
    createActions<void, void>('KEY_PHRASE_SYNONYMS_RESET');
